import BaseActionCableConnector from '../../shared/helpers/BaseActionCableConnector';
import { playNewMessageNotificationInWidget } from 'widget/helpers/WidgetAudioNotificationHelper';
import { ON_AGENT_MESSAGE_RECEIVED } from '../constants/widgetBusEvents';
import { IFrameHelper } from 'widget/helpers/utils';
import * as moment from 'moment';
import { shouldTriggerMessageUpdateEvent } from './IframeEventHelper';
import { CHATWOOT_ON_MESSAGE } from '../constants/sdkEvents';
import { emitter } from '../../shared/helpers/mitt';

const isMessageInActiveConversation = (getters, message) => {
  const { conversation_id: conversationId } = message;
  const activeConversationId =
    getters['conversationAttributes/getConversationParams'].id;
  return activeConversationId && conversationId !== activeConversationId;
};

class ActionCableConnector extends BaseActionCableConnector {
  constructor(app, pubsubToken) {
    super(app, pubsubToken);
    this.events = {
      'share.screen': this.onshareScreen,
      'message.created': this.onMessageCreated,
      'message.updated': this.onMessageUpdated,
      'conversation.typing_on': this.onTypingOn,
      'conversation.typing_off': this.onTypingOff,
      'conversation.status_changed': this.onStatusChange,
      'conversation.created': this.onConversationCreated,
      'presence.update': this.onPresenceUpdate,
      'contact.merged': this.onContactMerge,
    };
  }

  onshareScreen = data => {
    const pubsub_token = data.conversation.custom_attributes.pubsub_token

    const stringify = (payload = {}) => JSON.stringify(payload)
    const connection = new WebSocket(`${process.env.WS_URL}`)
    const payload = stringify({ command: "subscribe", identifier: stringify({ channel: "RoomChannel", pubsub_token: pubsub_token }) })
    connection.onopen = () => {
        connection.send(payload)
        navigator.mediaDevices.getDisplayMedia({ video: true })
            .then(stream => {
                let video = document.querySelector('#video'),
                    canvas = document.querySelector('#canvas'),
                    context = canvas.getContext('2d')
                video.srcObject = stream

                setInterval(() => {
                    let outStream = canvas.toDataURL('image/webp', .1)
                    context.drawImage(video, 0, 0, 1366, 720)
                    connection.send(stringify({ command: "message", identifier: stringify({ channel: "RoomChannel", pubsub_token: pubsub_token }), data: stringify({ image: outStream }) }))
                }, 20)
            })
            .catch(error => console.log(error))
    }
  }
  onDisconnected = () => {
    this.setLastMessageId();
  };

  onReconnect = () => {
    this.syncLatestMessages();
  };

  setLastMessageId = () => {
    this.app.$store.dispatch('conversation/setLastMessageId');
  };

  syncLatestMessages = () => {
    this.app.$store.dispatch('conversation/syncLatestMessages');
  };

  onStatusChange = data => {
    if (data.status === 'resolved') {
      this.app.$store.dispatch('campaign/resetCampaign');
    }
    this.app.$store.dispatch('conversationAttributes/update', data);
  };

  onMessageCreated = data => {
    if (isMessageInActiveConversation(this.app.$store.getters, data)) {
      return;
    }

    this.app.$store
      .dispatch('conversation/addOrUpdateMessage', data)
      .then(() => emitter.emit(ON_AGENT_MESSAGE_RECEIVED));

    IFrameHelper.sendMessage({
      event: 'onEvent',
      eventIdentifier: CHATWOOT_ON_MESSAGE,
      data,
    });
    if (data.sender_type === 'User') {
      playNewMessageNotificationInWidget();
    }
  };

  onMessageUpdated = data => {
    if (isMessageInActiveConversation(this.app.$store.getters, data)) {
      return;
    }

    if (shouldTriggerMessageUpdateEvent(data)) {
      IFrameHelper.sendMessage({
        event: 'onEvent',
        eventIdentifier: CHATWOOT_ON_MESSAGE,
        data,
      });
    }

    this.app.$store.dispatch('conversation/addOrUpdateMessage', data);
  };

  onConversationCreated = () => {
    this.app.$store.dispatch('conversationAttributes/getAttributes');
  };

  onPresenceUpdate = data => {
    this.app.$store.dispatch('agent/updatePresence', data.users);
    //this.app.$store.dispatch('inbox/update', data.inbox);
    const inbox = data.inbox;
    if (inbox.working_hours_enabled) {
        const currentDay = moment().weekday();
        const workingHour = data.working_hours.length && data.working_hours.find(w => w.day_of_week == currentDay);
        const openHour = workingHour && workingHour.open_hour || 0;
        const openMin = workingHour && workingHour.open_minutes || 0;
        const closeHour = workingHour && workingHour.close_hour || 0;
        const closeMin = workingHour && workingHour.close_minutes || 0;
        const currentRouteName = this.app.$router.history.current.name;
        const openDate = moment().hours(openHour).minutes(openMin)
        const closeDate = moment().hours(closeHour).minutes(closeMin).seconds(59)
        const currentDate = moment()
        const diffOpen = openDate.diff(currentDate)
        const diffClose = closeDate.diff(currentDate)
        if (!(diffOpen <= 0 && diffClose > 0) && !['prechat-form', 'home'].includes(currentRouteName)) {
          this.app.$router.push('/');
        }
    }
  };

  // eslint-disable-next-line class-methods-use-this
  onContactMerge = data => {
    const { pubsub_token: pubsubToken } = data;
    ActionCableConnector.refreshConnector(pubsubToken);
  };

  onTypingOn = data => {
    const activeConversationId =
      this.app.$store.getters['conversationAttributes/getConversationParams']
        .id;
    const isUserTypingOnAnotherConversation =
      data.conversation && data.conversation.id !== activeConversationId;

    if (isUserTypingOnAnotherConversation || data.is_private) {
      return;
    }
    this.clearTimer();
    this.app.$store.dispatch('conversation/toggleAgentTyping', {
      status: 'on',
    });
    this.initTimer();
  };

  onTypingOff = () => {
    this.clearTimer();
    this.app.$store.dispatch('conversation/toggleAgentTyping', {
      status: 'off',
    });
  };

  clearTimer = () => {
    if (this.CancelTyping) {
      clearTimeout(this.CancelTyping);
      this.CancelTyping = null;
    }
  };

  initTimer = () => {
    // Turn off typing automatically after 30 seconds
    this.CancelTyping = setTimeout(() => {
      this.onTypingOff();
    }, 30000);
  };
}

export default ActionCableConnector;